<template>
    <div class="screen-container">
        <div class="heading-text-content mb-4 text-gray-900">
            <div class="text-gray-900 step-indicator fs-14">STEP {{ currentStep }} OF 3</div>
            <h1 class="display-6 ff-montserrat screen-title">Setup Your Approval Checklist</h1>
            <p class="text-gray-600 fs-6 screen-description">You can require your approvers to acknowledge the following requirements
                before they approve a proof. We've created some default requirements for you. Feel free to delete,
                change or add to them!</p>
        </div>
        <div class="shadow-base bg-white rounded-2 mb-4">
            <div class="p-4">
                <ul class="d-flex flex-column gap-2 list-unstyled mb-0">
                    <li v-for="(item, index) in checklistItems.items" :key="index" class="d-flex align-items-center gap-2">
                        <div class="flex-fill">
                            <input type="text" class="form-control border-gray-300 fs-14 checklist-input rounded-2 text-gray-900"
                                v-model="checklistItems.items[index].name">
                        </div>
                        <div class="flex-shrink-0">
                            <button @click="deleteChecklistProperty(index)" class="btn p-0">
                                <img src="/img/trash-red.svg" width="24" alt="Delete">
                            </button>
                        </div>
                    </li>
                    <div class="d-flex justify-content-end">
                        <button @click="addChecklistItem" 
                            class="btn btn-light fw-normal text-ashore-black fs-14 px-3 py-2 add-checklist-button">
                            Add Checklist Item
                        </button>
                    </div>
                </ul>
            </div>
        </div>
        <div class="d-inline-flex gap-2 flex-wrap">
            <button @click="saveChecklist" class="btn btn-success fw-normal px-4 py-12 button-final">Get Started</button>
            <button @click="handlePrevStep" class="btn btn-light fw-normal text-gray-700 previous-button">Previous</button>
        </div>
    </div>
</template>
<script>

import { ALERT_TYPE } from '../../utils/constants';

const { WARNING } = ALERT_TYPE;

export default {
    name: "Screen3",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        handleNextStep: {
            type: Function,
            required: true
        },
        handlePrevStep: {
            type: Function,
            required: true
        },
        checklistItems: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            accountWide: true,
            checkListId: null
        };
    },
    methods: {
        addChecklistItem() {
            this.checklistItems.items.push({ name: "" });
        },
        deleteChecklistProperty(index) {
            this.checklistItems.items.splice(index, 1);
        },

        validateChecklist() {
            if (!this.checklistItems.items || this.checklistItems.items.length === 0) {
                this.$A.AlertUser("Please add at least one Checklist item.", WARNING);
                return false;
            }
            const invalidItem = this.checklistItems.items.find(item => !item.name || item.name.trim() === "");
            if (invalidItem) {
                this.$A.AlertUser("Warning : Approval Checklist Cannot be Empty. ", WARNING);
                return false;
            }
            return true;
        },

        async saveChecklist() {
            if (!this.validateChecklist()) return;
            try {
                const checklistData = {
                    id: this.checklistItems.id,
                    name: "Default Checklist",
                    accountWide: this.accountWide,
                    items: this.checklistItems.items,
                };
                const savedChecklist = await this.$A.ProofChecklistService.SaveProofChecklist(checklistData);
                if (savedChecklist.id > 0) {
                    this.checkListId = savedChecklist.id;
                    for (const item of this.checklistItems.items) {
                        await this.$A.ProofChecklistService.SaveProofChecklistProperty(
                            savedChecklist.id,
                            item.id || null,
                            {
                                checklistId: savedChecklist.id,
                                name: item.name
                            }
                        );
                    }
                    this.$emit('show-modal');
                    this.$emit('update:currentStep', 4);
                } else {
                    this.$A.AlertUser("Failed to save Checklist", WARNING);
                }
            } catch (error) { 
                this.$A.AlertUser("Error saving Checklist:", WARNING);
            }
        },
    }
};
</script>
<style scoped>
.screen-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 4rem;
}

.heading-text-content {
    display: flex;
    flex-direction: column;
}

.button-final {
    font-size: 16px;
    font-weight: 400;
    padding: 13px 34.5px;
    color: #F9F9F9;
}

.step-indicator {
    font-weight: 700;
}

.screen-title {
    font-weight: 800;
    font-size: 36px;
    max-width: 70%;
    margin-bottom: 16px;
}

.screen-description {
    font-size: 16px;
}

.checklist-input {
    font-weight: 400;
}

.add-checklist-button {
    font-weight: 400;
    background-color: #EEF2F5;
}

.previous-button {
    font-size: 16px;
    font-weight: 400;
    padding: 13px 34.5px;
    border: 1px solid #b5b5b8;
    background-color: white;
}
</style>
